"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noticeCreateApi = noticeCreateApi;
exports.noticeDeleteApi = noticeDeleteApi;
exports.noticeDetailApi = noticeDetailApi;
exports.noticeListApi = noticeListApi;
exports.noticeUpdateApi = noticeUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function noticeCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/notice/save',
    method: 'POST',
    data: data
  });
}
function noticeUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/notice/update',
    method: 'POST',
    data: data
  });
}
function noticeDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/notice/info/".concat(id),
    method: 'GET'
  });
}
function noticeDeleteApi(data) {
  return (0, _request.default)({
    url: "/admin/notice/delete",
    method: 'get',
    params: data // 接收对象参数
  });
}
function noticeListApi(params) {
  return (0, _request.default)({
    url: '/admin/notice/list',
    method: 'GET',
    params: params
  });
}